/*	--------------------------------------------------
== MENU
-------------------------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
    let mmenuInitialized = false;

    function initMmenuIfNeeded() {
        const isMobile = window.innerWidth < 1200;

        if (isMobile && !mmenuInitialized) {
            new Mmenu("#menu", {
                // options
            }, {
                offCanvas: {
                    page: {
                        selector: "#page"
                    }
                }
            });

            mmenuInitialized = true;

            // Masquer le menu desktop si besoin
            const menuContainer = document.getElementById("menu-container");
            if (menuContainer) {
                menuContainer.style.display = "none";
            }
        }

        if (!isMobile) {
            // Montrer le menu desktop
            const menuContainer = document.getElementById("menu-container");
            if (menuContainer) {
                menuContainer.style.display = "";
            }

            // Ajouter les classes submenu
            const menuItems = document.querySelectorAll("#menu li");
            menuItems.forEach(item => {
                if (item.querySelector("ul")) {
                    item.classList.add("has-submenu");
                }
            });
        }
    }

    // Init au chargement
    initMmenuIfNeeded();

    // Init au redimensionnement
    window.addEventListener("resize", () => {
        initMmenuIfNeeded();
    });

    // Scroll vers la carte
    if (document.querySelector("[data-filtered]")) {
        const map = document.getElementById("map");
        if (map) map.scrollIntoView({ behavior: "smooth" });
    }

    // DEBUG BOUTONS REJOIGNEZ-NOUS
    document.querySelectorAll('#v-pills-tab li').forEach(function (el) {
        el.addEventListener('click', function () {
            document.querySelector('.page-join__reasons__nav__item.active').classList.remove('active');
            document.querySelector('.page-join__reasons__nav__item').setAttribute('aria-selected', 'false');
            el.classList.add('active');
            el.setAttribute('aria-selected', 'true');
            document.querySelector('.tab-pane.show.active').classList.remove('show', 'active')
            document.getElementById(el.getAttribute('aria-controls')).classList.add('show', 'active');
        })
    })
});



/*	--------------------------------------------------
== slider homepage
-------------------------------------------------- */
if(jQuery('[data-slider=fn_services-list__slider]').length){
    jQuery('[data-slider=fn_services-list__slider]').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        //centerMode: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== slider dates page Le Groupe
-------------------------------------------------- */
if(jQuery('[data-slider=fn_page-group__dates__slider]').length){
    jQuery('[data-slider=fn_page-group__dates__slider]').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== slider Nos autres filiales page filiales détail
-------------------------------------------------- */
if(jQuery('[data-slider=fn_filiales-detail__other__slider]').length){
    jQuery('[data-slider=fn_filiales-detail__other__slider]').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== slider galerie page Le Groupe
-------------------------------------------------- */
if(jQuery('[data-slider=fn_page-group__gallery__slider]').length){
    jQuery('[data-slider=fn_page-group__gallery__slider]').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== slider galerie page actualités détail
-------------------------------------------------- */
if(jQuery('[data-slider=fn_page-actu__gallery__slider]').length){
    jQuery('[data-slider=fn_page-actu__gallery__slider]').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== slider témoignages page Rejoignez-nous
-------------------------------------------------- */
if(jQuery('[data-slider=fn_page-join__testimonials__slider]').length){
    jQuery('[data-slider=fn_page-join__testimonials__slider]').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== slider dates page Le Groupe
-------------------------------------------------- */
if(jQuery('[data-slider=fn_page-join__professions__slider]').length){
    jQuery('[data-slider=fn_page-join__professions__slider]').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    });
}


/*	--------------------------------------------------
== scroll to, page filiales
-------------------------------------------------- */
if(document.querySelector('.fn-anchor-top')) {
    document.querySelector('.fn-anchor-top').addEventListener('click', function(event) {
        event.preventDefault();
        window.scrollTo({
            top: document.querySelector('#anchor-top').offsetTop,
            behavior: 'smooth'
        });
    });
}

